import Vue from 'vue'
import Vuex from 'vuex'

import { app } from './app.module'
import { auth } from './auth.module'
import { card } from './card.module'
import { chat } from './chat.module'
import { contractAttendanceTasks } from './contractAttendanceTasks.module'
import { contractGeneration } from './contractGeneration.module'
import { dataTable } from './dataTable.module'
import { digitalSignatureStore } from './digitalSignature.module'
import { ERP } from './erp.module'
import { facebook } from './facebook.module'
import { formTracker } from './formTracker.module'
import { launchDay } from './launch.module'
import { lead } from './lead.module'
import { menu } from './menu.module'
import { modals } from './modals.module'
import { NPS } from './nps.module'
import { openSearch } from './openSearch.module'
import { product } from './product.module'
import { productCategory } from './productCategory.module'
import { profile } from './profile.module'
import { salesTable } from './salesTable.module'
import { simulation } from './simulation.module'
import { switchButton } from './switchButton.module'
import { table } from './table.module'
import { websocketDeploymentImageModule } from './websocketDeploymentImage.module'
import { dashboardFilter } from './dashboardFilter'
import { whatsapp } from './whatsapp.module'
import { detailsHasPermissions } from './detailsHasPermissions.module'
import { exclusiveManagement } from './exclusiveManagement.module'

import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        auth,
        app,
        formTracker,
        salesTable,
        product,
        simulation,
        productCategory,
        contractGeneration,
        dataTable,
        dashboardFilter,
        facebook,
        lead,
        chat,
        menu,
        profile,
		whatsapp,
        modals,
        openSearch,
        switchButton,
		NPS,
        launchDay,
        ERP,
        table,
        card,
        digitalSignatureStore,
        contractAttendanceTasks,
        websocketDeploymentImageModule,
        detailsHasPermissions,
        exclusiveManagement
    },
    getters
})

export default store
